import { combineReducers } from "redux";
import doorsReducer from "./doorsReducer";
import itemsReducer from "./itemsReducer";
import printersReducer from "./printersReducer";
import readersReducer from "./readersReducer";

export default combineReducers({
  doors: doorsReducer,
  items: itemsReducer,
  printers: printersReducer,
  readers: readersReducer,
});
